import { useUserContext } from '@logic/contexts/AppStore/UserContext.tsx'
import { UserView } from './UserView/UserView.tsx'
import { AdminView } from './AdminView.tsx'
import { AssistantView } from './AssistantView.tsx'
import { useDocumentTitle } from '@src/hooks/useDocumentTitle.ts'
import { useLearnerShow } from '@src/logic/contexts/Learners/LearnerShowContext.tsx'
import { LxLoadingSpinner } from '@src/components/loader/loadingSpinner.tsx'
import { USER_ROLE } from '@src/utils/constants.ts'
import { CAN_ASSIGN_LEARNER_STUDENT_TO_OTHERS } from '@src/logic/contexts/AppStore/UserPermissions.constant.ts'
import { UserAssignOtherUserView } from './UserView/UserAssignOtherUserView.tsx'

export const LearnerTeamMembers = () => {
  useDocumentTitle('Learner Team Members')

  const { currentUser } = useUserContext() as any
  const { learner, isLoading } = useLearnerShow()

  let roleComponent

  if (currentUser.userRole === USER_ROLE.ACCOUNT_ADMIN) {
    roleComponent = <AdminView />
  } else if (currentUser.userRole === USER_ROLE.ADMIN) {
    roleComponent = <AdminView />
  } else if (currentUser.userRole === USER_ROLE.USER) {
    // 11/12/2025 - With new addition , User role can assign learner to other users if they have permission AC-2310-UL-001
    // So checking user has AC-2310-UL-001 then return AdminView otherwise defautl UserView

    const assignees = (learner?.assigneeUsers ?? []) as unknown as Array<Record<string, string[]>>

    // Find entry where key === currentUser.id
    const userAssignmentsEntry = assignees.find((entry) => Object.prototype.hasOwnProperty.call(entry, currentUser.id))

    const userAssignments: string[] = userAssignmentsEntry ? userAssignmentsEntry[currentUser.id] : []

    const assignedToOtherUsersPermission = userAssignments.includes(CAN_ASSIGN_LEARNER_STUDENT_TO_OTHERS)

    roleComponent = assignedToOtherUsersPermission ? <UserAssignOtherUserView  currentUser = {currentUser}   /> : <UserView currentUserId={currentUser.id} />

  } else if (currentUser.userRole === USER_ROLE.ASSISTANT) {
    roleComponent = <AssistantView />
  }

  return isLoading ? <LxLoadingSpinner /> : roleComponent
}
